<script lang="ts">
    import { BREAKPOINTS } from "@/constants/break_points";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { map } from "rxjs";

    import { containerQueryWidthContextToken } from "./context_tokens";

    const width$ = getTypedContext(containerQueryWidthContextToken);

    $: breakpoints$ = width$.pipe(
        map((width) => ({
            width,
            smUp: width >= BREAKPOINTS.sm,
            mdUp: width >= BREAKPOINTS.md,
            lgUp: width >= BREAKPOINTS.lg,
            xlUp: width >= BREAKPOINTS.xl,
        }))
    );
</script>

<slot
    smUp={$breakpoints$?.smUp}
    mdUp={$breakpoints$?.mdUp}
    lgUp={$breakpoints$?.lgUp}
    xlUp={$breakpoints$?.xlUp}
    width={$breakpoints$?.width}
/>
